/*
  COMMON
 */
import { isNull, isUndefined, values } from "lodash";
import getSymbolFromCurrency from 'currency-symbol-map';
import { t } from "i18next";
const userData = JSON.parse(localStorage.getItem("user"));

  const loginType = {
    GOOGLE: "google",
    ID_PSWD: "id/pswd"
  };

  const module = {
    DP: "DP",
    RP: "RP",
    IP: "IP",
    MP: "MP",
    BF: "BF"
  };

  const roles = {
    ADMIN: "ROLE_ADMIN",
    GUEST: "ROLE_GUEST",
    DP_MGR: "ROLE_DP_MGR",
    DP_USER: "ROLE_DP_USER",
    IP_MGR: "ROLE_IP_MGR",
    IP_USER: "ROLE_IP_USER",
    RP_MGR: "ROLE_RP_MGR",
    RP_USER: "ROLE_RP_USER",
    APP_DP: "ROLE_APP_DP",
    APP_IP: "ROLE_APP_IP",
    APP_RP: "ROLE_APP_RP",
    APP_MP: "ROLE_APP_MP",
    MP_MGR: "ROLE_MP_MGR",
    MP_USER: "ROLE_MP_USER",
    APP_BF: "ROLE_APP_BF",
    APP_BI: "ROLE_APP_BI",
    APP_AI: "ROLE_APP_AI",
  }

  const buckets = {
    DAY: "day",
    WEEK: "week",
    PARTIAL_WEEK: "partialWeek",
    MONTH: "month",
    QUARTER: "quarter",
    YEAR: "year"
  };

  const isWeekBucket = (bucket) => {
    if (bucket === null) {
      return false;
    }
    return !isUndefined(bucket) && ( bucket.toLowerCase() === buckets.WEEK.toLowerCase()  || bucket.toLowerCase()  === buckets.PARTIAL_WEEK.toLowerCase() ) ;
  }

  const dayOfWeek = {
    MONDAY: { id: 1, cd: "mon", name: "Mon" },
    TUESDAY: { id: 2, cd: "tue", name: "Tue" },
    WEDNESDAY: { id: 3, cd: "wed", name: "Wed" },
    THURSDAY: { id: 4, cd: "thu", name: "Thu" },
    FRIDAY: { id: 5, cd: "fri", name: "Fri" },
    SATURDAY: { id: 6, cd: "sat", name: "Sat" },
    SUNDAY: { id: 0, cd: "sun", name: "Sun" }
  };

  const muicolor = {
    DEFAULT: "default",
    INFO: "info"
  };

  const toggleType = {
    QTY: "qty",
    AMT: "amt",
    LINE: "line",
    AREA: "area",
    BAR: "bar",
    DASHED: "dashed",   // 점선 라인 — ChartComposed / PivotChartComposed 가 렌더
    REVENUE: "revenue",
    FREQUENCY: "frequency"
  };

  const filterType = {
    equal: {cd: "equal", symbol: "="},
    notEqual: { cd: "notEqual", symbol: "≠"},
    and: {cd: "and", symbol: "AND"},
    or: { cd: "or", symbol: "OR"}
  }

  const locationType = {
    PLANT: {cd: "PLANT", name: "prodPlant"},
    DC: {cd: "DC", name: "distributionCenter"},
    WHSE: {cd: "WHSE", name: "warehouse"},
    STO: {cd: "STO", name: "store"},
    CUST: {cd: "CUST", name: "customer"},
    VENDOR: {cd: "VENDOR", name: "vendor"},
    VIRTUAL_DC: {cd: "VIRTUAL_DC", name: "virtualDc"}
  };

  const itemType = {
    RM: {cd: "RM", name: "rawMaterial"},
    FG: {cd: "FG", name: "finishedGoods"},
    SFG: {cd: "SFG", name: "semiFinishedGoods"},
    KIT: {cd: "KIT", name: "salesKit"}
  };

  const calendarType = {
    NOP: "nop",
    RO: "ro",
    DP: "demandPlan"
  }

  const orderType = {
    PLAN_ORDER: "planOrder",
    URGENT: "urgent"
  }

  const ganttOrderType = {
    PLAN_ORDER: "planOrder",
    URGENT: "urgent",
    PO: "planOrder",
    SO: "salesOrder",
    RP: "replenishment",
    DP: "demandPlan",
    CO: "confirmedOrder"
  }

  const baseVersionStatusCode = {
    RELEASED: "RELEASED",
    DELETE: "DELETE"
  }

  const attributes = [
    "attr01", "attr02", "attr03", "attr04", "attr05", "attr06", "attr07", "attr08", "attr09", "attr10"
  ];

  const transformSourceData = {
    INVENTORY_AGG: "inventoryAggMon",
    SALES_PLAN: "salesPlan"
  }

  const hrchyNum = {
    HRCHY: 1,
    HRCHY02: 2,
    HRCHY03: 3,
    HRCHY04: 4,
    HRCHY05: 5,
  }

  const shipmentCondition = [
    { cd: "eta", name: "eta" },
    { cd: "etd", name: "etd" },
    { cd: "atd", name: "atd" },
    { cd: "ata", name: "ata" },
  ];

  const intransitCondition = [
    { cd: "eta", name: "eta" },
    { cd: "etd", name: "etd" },
    { cd: "atd", name: "atd" },
  ]

  // 안건 검색의 날짜 축. 회의 시간과 작성 시간은 끝까지 별개 축이다 —
  // 하나로 합치면 "다음 주 회의"와 "지난주에 쓴 글"을 구분할 수 없다.
  const meetingAgendaDateCondition = [
    { cd: "meeting", name: "meetingAgendaDateMeeting" },
    { cd: "created", name: "meetingAgendaDateCreated" },
  ]
  const orderListCondition = [
    { cd: "orderDate", name: "orderDate" },
    { cd: "dueIn", name: "dueIn" }
  ]

  const cycleUoms = [
    { value: "S", text: "cycleOnce" },
    { value: "D", text: "cycleDay" },
    { value: "W", text: "cycleWeek" },
    { value: "M", text: "cycleMonth" },
    { value: "Y", text: "cycleYear" }
  ];

  const getCurrencySymbol = (code) => {
    const symbol = getSymbolFromCurrency(code);
    if (isUndefined(symbol)) {
      return userData.currencySymbol;
    }
    return getSymbolFromCurrency(code);
  }

  const limitVersion = 100;

  // Lot Size Calculation (Ref: QuantityUtils.java)
  const splitByMaxLot = (requestQty, minLotSize, maxLotSize, multipleLotSize) => {
    let lotSize = 0;
    let remaining = requestQty;

    while (remaining > maxLotSize) {
      lotSize += maxLotSize;
      remaining -= maxLotSize;
    }

    if (remaining <= 0) {
      return lotSize;
    }

    if (remaining < minLotSize) {
      return lotSize + minLotSize;
    }

    if (Number.isFinite(multipleLotSize) && multipleLotSize > 0) {
      const multipleCount = Math.ceil(remaining / multipleLotSize);
      return lotSize + (multipleCount * multipleLotSize);
    }

    return lotSize + remaining;
  }

  const roundUpFrom = (base, target, increment) => {
    if (target <= base) {
      return base;
    }

    const diff = target - base;
    const steps = Math.ceil(diff / increment);
    return base + (steps * increment);
  }

  const calculateLotSize = (requestQty, minLotSize, maxLotSize, multipleLotSize) => {
    const parsedRequestQty = Number(requestQty);
    let parsedMinLotSize = Number(minLotSize);
    let parsedMaxLotSize = Number(maxLotSize);
    const parsedMultipleLotSize = Number(multipleLotSize);

    if (!Number.isFinite(parsedRequestQty) || parsedRequestQty <= 0) {
      return 0;
    }

    const hasMinLot = Number.isFinite(parsedMinLotSize) && parsedMinLotSize > 0;
    const hasMaxLot = Number.isFinite(parsedMaxLotSize) && parsedMaxLotSize > 0;
    const hasMultipleLot = Number.isFinite(parsedMultipleLotSize) && parsedMultipleLotSize > 0;

    if (!hasMinLot && !hasMaxLot && !hasMultipleLot) {
      return parsedRequestQty;
    }

    if (!hasMinLot && !hasMaxLot) {
      parsedMinLotSize = parsedMultipleLotSize;
      parsedMaxLotSize = parsedMultipleLotSize;
    }

    let normalizedMinLotSize = hasMinLot ? parsedMinLotSize : parsedMaxLotSize;
    let normalizedMaxLotSize = hasMaxLot ? parsedMaxLotSize : parsedMinLotSize;

    if (parsedRequestQty <= normalizedMinLotSize) {
      return normalizedMinLotSize;
    }

    if (normalizedMaxLotSize > normalizedMinLotSize) {
      return splitByMaxLot(
        parsedRequestQty,
        normalizedMinLotSize,
        normalizedMaxLotSize,
        parsedMultipleLotSize
      );
    }

    const increment = Number.isFinite(parsedMultipleLotSize) && parsedMultipleLotSize > 0
      ? parsedMultipleLotSize
      : normalizedMinLotSize;

    return roundUpFrom(normalizedMinLotSize, parsedRequestQty, increment);
  }

  const makeKey = (keyArray = [], cellTarget = null) => {
    const SPLITTER = "#SPLIT#";

    if (isNull(cellTarget)) {
      return "";
    }

    return keyArray
      .filter(field => cellTarget?.[field])
      .map(field => cellTarget[field])
      .join(SPLITTER);
  };

  /* 노트를 쓰는 MP 화면(viewName). NotesModal 도 이 목록으로 MP 인지 판단한다 */
  const MP_NOTE_PAGES = ["MP_PLAN_REVIEW", "MP_PSI_SIMULATION"];

  const getNoteKey = (pageCd, cellTarget) => {
    const PSI_SIMULATION = "PSI_SIMULATION";
    const RP_REVIEW = "RP_REVIEW";
    const DP_WORKBENCH = "DP_WORKBENCH";
    const CHANNEL_WORKBENCH = "DP_CHANNEL_WORKBENCH";
    const [MP_PLAN_REVIEW, MP_PSI_SIMULATION] = MP_NOTE_PAGES;
    let noteKey = "";

    switch (pageCd) {
      case CHANNEL_WORKBENCH:
      case DP_WORKBENCH: {
        noteKey = makeKey(["customerHrchyCd", "itemHrchyCd", "baseDate", "measureCd"], cellTarget);
        break;
      }
      case PSI_SIMULATION:
      case RP_REVIEW: {
        if (cellTarget.originMeasure) {
          noteKey = makeKey(["originLocCd", "destLocCd", "itemCd", "baseDate", "originMeasure"], cellTarget);
        } else {
          noteKey = makeKey(["originLocCd", "destLocCd", "itemCd", "baseDate", "measure"], cellTarget);
        }
        break;
      }
      // MP 는 z_note 에 loc = 공장으로 저장한다. 행이 공장 × 품목 × measure 라 출발/도착 구분이 없다.
      case MP_PLAN_REVIEW:
      case MP_PSI_SIMULATION: {
        noteKey = makeKey(["locCd", "itemCd", "baseDate", "measure"], cellTarget);
        break;
      }
      default:
        break;
    }
    return noteKey;
  };


/*
  DP
 */
const dpMeasure = {
  BF_QTY: {
    cd: "BF_QTY",
    name: "baselineQty",
    common: "BF",
    pair: "BF_AMT"
  },
  BF_AMT: {
    cd: "BF_AMT",
    name: "baselineAmt",
    common: "BF",
    pair: "BF_QTY"
  },
  ASP: {
    cd: "ASP",
    name: "avgPrice",
    common: "ASP"
  },
  YOY_AMT: {
    cd: "YOY_AMT",
    name: "salesActualYoYAmt",
    common: "YOY",
    pair: "YOY_QTY"
  },
  YOY_QTY: {
    cd: "YOY_QTY",
    name: "salesActualYoYQty",
    common: "YOY",
    pair: "YOY_AMT"
  },
  SA_AMT: {
    cd: "SA_AMT",
    name: "salesActualAmt",
    common: "SA",
    pair: "SA_QTY"
  },
  SA_QTY: {
    cd: "SA_QTY",
    name: "salesActualQty",
    common: "SA",
    pair: "SA_AMT"
  },
  MF_AMT: {
    cd: "MF_AMT",
    name: "managerAmt",
    common: "MF",
    pair: "MF_QTY"
  },
  MF_QTY: {
    cd: "MF_QTY",
    name: "managerQty",
    common: "MF",
    pair: "MF_AMT"
  },
  SF_AMT: {
    cd: "SF_AMT",
    name: "salesForecastAmt",
    common: "SF",
    pair: "SF_QTY"
  },
  SF_QTY: {
    cd: "SF_QTY",
    name: "salesForecastQty",
    common: "SF",
    pair: "SF_AMT"
  },
  FF_AMT: {
    cd: "FF_AMT",
    name: "financeAmt",
    common: "FF",
    pair: "FF_QTY"
  },
  FF_QTY: {
    cd: "FF_QTY",
    name: "financeQty",
    common: "FF",
    pair: "FF_AMT"
  },
  MK_AMT: {
    cd: "MK_AMT",
    name: "marketingAmt",
    common: "MK",
    pair: "MK_QTY"
  },
  MK_QTY: {
    cd: "MK_QTY",
    name: "marketingQty",
    common: "MK",
    pair: "MK_AMT"
  },
  PM_QTY: {
    cd: "PM_QTY",
    name: "promotionQty",
    common: "PM"
  },
  PMP: {
    cd: "PMP",
    name: "promotionPrice",
    common: "PMP"
  },
  COST: {
    cd: "COST",
    name: "costAmt",
    common: "MF"
  },
  PROFIT: {
    cd: "PROFIT",
    name: "profit",
    common: "PROFIT"
  },
  LR_AMT: {
    cd: "LR_AMT",
    name: "lastReleasedAmt",
    common: "LR",
    pair: "LR_QTY"
  },
  LR_QTY: {
    cd: "LR_QTY",
    name: "lastReleasedQty",
    common: "LR",
    pair: "LR_AMT"
  },
  SO_AMT: {
    cd: "SO_AMT",
    name: "salesOrderAmt",
    common: "SO",
    pair: "SO_QTY"
  },
  SO_QTY: {
    cd: "SO_QTY",
    name: "salesOrderQty",
    common: "SO",
    pair: "SO_AMT"
  },
  SALES_PLAN_AMT: {
    cd: "SALES_PLAN_AMT",
    name: "salesPlanAmt",
    common: "SP",
    pair: "SALES_PLAN_QTY"
  },
  SALES_PLAN_QTY: {
    cd: "SALES_PLAN_QTY",
    name: "salesPlanQty",
    common: "SP",
    pair: "SALES_PLAN_AMT"
  },
  ASA_AMT: {
    cd: "ASA_AMT",
    name: "avgSalesActualAmt",
    common: "ASA",
    pair: "ASA_QTY"
  },
  ASA_QTY: {
    cd: "ASA_QTY",
    name: "avgSalesActualQty",
    common: "ASA",
    pair: "ASA_AMT"
  },
  BOH: {
    cd: "BOH",
    name: "arrivalQty",
    common: "BOH"
  },
  COGS: {
    cd: "COGS",
    name: "cogs",
    common: "COGS"
  },
  POS_SA_QTY: {
    cd: "POS_SA_QTY",
    name: "posSalesActualQty",
    common: "POS_SA"
  },
  POS_YOY_QTY: {
    cd: "POS_YOY_QTY",
    name: "posSalesActualYoYQty",
    common: "POS_YOY"
  },
  POS_ASA_QTY: {
    cd: "POS_ASA_QTY",
    name: "posAvgSalesActualQty",
    common: "POS_ASA"
  },
  POS_LR_QTY: {
    cd: "POS_LR_QTY",
    name: "lastReleasedPosQty",
    common: "POS_LR"
  },
  POS_QTY: {
    cd: "POS_QTY",
    name: "posQty",
    common: "POS"
  },
  INV_BOH_QTY: {
    cd: "INV_BOH_QTY",
    name: "invBohQty",
    common: "INV_BOH"
  },
  INV_EOH_QTY: {
    cd: "INV_EOH_QTY",
    name: "invEohQty",
    common: "INV_EOH"
  },
  INV_DAYS_BOH: {
    cd: "INV_DAYS_BOH",
    name: "invDaysBoh",
    common: "INV_DAYS_BOH"
  },
  INV_DAYS_EOH: {
    cd: "INV_DAYS_EOH",
    name: "invDaysEoh",
    common: "INV_DAYS_EOH"
  },
  TARGET_INV_QTY_EOH: {
    cd: "TARGET_INV_QTY_EOH",
    name: "targetInvQty",
    common: "TARGET_INV_QTY_EOH"
  },
  TARGET_INV_DAYS: {
    cd: "TARGET_INV_DAYS",
    name: "targetInvDays",
    common: "TARGET_INV_DAYS"
  },
  MF_VS_SUGGESTED_QTY: {
    cd: "MF_VS_SUGGESTED_QTY",
    name: "mfVsSuggestedQty",
    common: "MF_VS_SUGGESTED"
  },
  TURN_DAYS_TARGET: {
    cd: "TURN_DAYS_TARGET",
    name: "turnDaysTarget",
    common: "TURN_DAYS_TARGET"
  },
  SUGGESTED_MP_QTY: {
    cd: "SUGGESTED_MP_QTY",
    measureCd: "SUGGESTED_MP_QTY",
    name: "suggestedMpQty",
    common: "SUGGESTED_MP",
    valueTypeCd: "QTY"
  }
};

const channelOnlyMeasureCds = [
  "POS_QTY", "POS_SA_QTY", "POS_YOY_QTY", "POS_ASA_QTY", "POS_LR_QTY",
  "INV_BOH_QTY", "INV_EOH_QTY", "INV_DAYS_BOH", "INV_DAYS_EOH",
  "TARGET_INV_QTY_EOH", "TARGET_INV_DAYS", "SUGGESTED_MP_QTY", "MF_VS_SUGGESTED_QTY",
  "TURN_DAYS_TARGET",
];

const USER_MEASURE = "USER_MEASURE";

const dpComputeDefaultMeasure = {
  MF_QTY: dpMeasure.MF_QTY,
  SF_QTY: dpMeasure.SF_QTY
}

const dpcommonMeasureCd = {
  MF: {
    name: "managerForecast",
    value: [dpMeasure.MF_AMT, dpMeasure.MF_QTY],
  },
  SF: {
    name: "salesForecast",
    value: [dpMeasure.SF_AMT, dpMeasure.SF_QTY],
  },
  FF: {
    name: "financeForecast",
    value: [dpMeasure.FF_AMT, dpMeasure.FF_QTY],
  },
  MK: {
    name: "marketingForecast",
    value: [dpMeasure.MK_AMT, dpMeasure.MK_QTY],
  },
  SP: {
    name: "salesPlan",
    value: [dpMeasure.SALES_PLAN_AMT, dpMeasure.SALES_PLAN_QTY],
  },
  PM: {
    name: "promotionQty",
    value: [dpMeasure.PM_QTY],
  },
  PMP: {
    name: "promotionPrice",
    value: [dpMeasure.PMP],
  },
};

const nonRuleMeasureCds = [
  dpMeasure.BF_QTY.cd, dpMeasure.BF_AMT.cd, dpMeasure.PMP.cd, dpMeasure.ASP.cd,
  dpMeasure.SA_AMT.cd, dpMeasure.SA_QTY.cd, dpMeasure.YOY_AMT.cd, dpMeasure.YOY_QTY.cd,
  dpMeasure.LR_QTY.cd, dpMeasure.LR_AMT.cd, dpMeasure.BOH.cd, dpMeasure.COGS.cd,
  dpMeasure.ASA_QTY.cd, dpMeasure.ASA_AMT.cd, dpMeasure.PROFIT.cd, dpMeasure.COST.cd,
  dpMeasure.SO_AMT.cd, dpMeasure.SO_QTY.cd,
];

// nonRuleMeasureCds라 편집 불가지만, aggregation 규칙(SUM/NONE)만은 DP setting에서 설정 가능한 measure (예: arrivalQty=BOH)
const aggEditableMeasureCds = [
  dpMeasure.BOH.cd,
];

const dpAggRules = {
  SUM: { cd: "SUM", name: "sum" },
  NONE: { cd: "NONE", name: "NotAggregation" }
};

const dpDisAggRules = {
  EQUAL: { cd: "EQUAL", name: "equal" },
  QTY_EQUAL: { cd: "QTY_EQUAL", name: "qtyEqual" },
  COPY: { cd: "COPY", name: "copy" },
  PROPORTION: { cd: "PROPORTION", name: "proportion" },
  ITEM_RATIO: { cd: "ITEM_RATIO", name: "userDefined(item)" },
  CUST_RATIO: { cd: "CUST_RATIO", name: "userDefined(customer)" },
  ITEM_CUST: { cd: "ITEM_CUST", name: "userDefined(itemToCustomer)" },
  CUST_ITEM: { cd: "CUST_ITEM", name: "userDefined(customerToItem)" },
  NONE: { cd: "NONE", name: "NotDisaggregation" }
};

const dpDisAggTarget = {
  QTY: { cd: "QTY", name: "qty" },
  AMT: { cd: "AMT", name: "amt" },
  INDEPENDENT: { cd: "INDEPENDENT", name: "independent" }
};

const dpInitalValues = {
  LAST_ACTUAL_SALES: "lastSalesActual",
  ACTUAL_SALES_YOY: "salesActualYoY",
  LAST_RELEASED_VERSION: "lastReleasedVersion",
  SALES_PLAN_MEASURE: "salesPlanMeasure",
  FINANCE_PLAN: "financePlan",
  NOTINITIAL: "notInitialized",
  CUSTOMIZATION: "layout",
  DP_VERSION: "dpVersion",
  MEASURE_CUSTOM: "measureCustom"
};

const dpSettingCode = {
  BASELINE_FORECAST: "baselineForecast",
  ITEM_LEVEL_ID: "itemLevelId",
  CUST_LEVEL_ID: "custLevelId",
  CUST_LEVEL: "custLevel",
  ITEM_LEVEL: "itemLevel",
  ROLLING_RANGE: "rollingRange",
}

const dpVersion = {
  RELEASED: "RELEASED",
  RELEASING: "RELEASING",
  DEFAULT: "DEFAULT",
  SCENARIO: "SCENARIO",
  REFERENCE: "REFERENCE",
  READY: "READY",
  RUNNING: "RUNNING"
};

/*
  계획 버전 상태코드(status_cd) → 언어팩 키.

  왜 매핑이 필요한가 — 언어팩의 상태 라벨은 **소문자 키**(`planned`/`released`/…)로 들어 있는데
    코드가 들고 다니는 값은 **대문자 상태코드**다. 대문자를 그대로 조회하면 키를 못 찾아
    화면에 `PLANNED` 같은 원문이 그대로 뜬다(2026-08 까지 실제로 그랬다).

  ⚠️ 일괄 toLowerCase 로 때우면 안 된다 — 소문자 `scenario` 는 **"버전(Version)"** 이라는
    전혀 다른 뜻의 키다. 지금 유일하게 제대로 나오던 SCENARIO 가 오히려 "버전" 으로 망가진다.
    SCENARIO 만 대문자 키(fp 섹션)를 쓴다. 그래서 코드별로 쓸 키를 손으로 적는다.
*/
const versionStatusL10NKey = {
  SCENARIO: "SCENARIO",   // ★ 대문자 키. 소문자 scenario 는 "버전" 이라 쓰면 안 된다
  PLANNED: "planned",
  UNPLANNED: "unplanned",
  RELEASED: "released",
  RELEASING: "releasing",
  RUNNING: "running",
  FAILED: "failed",
  READY: "ready",
  UPDATING: "updating",
  REFERENCE: "reference",
  DEFAULT: "default",
  DELETE: "delete",
};

// 매핑에 없는 코드는 원문을 그대로 돌려준다 — 빈 칸보다 코드가 낫다.
const versionStatusLabel = (statusCd) => {
  if (statusCd == null || statusCd === "") return statusCd ?? "";
  const key = versionStatusL10NKey[statusCd];
  return key ? t(key, statusCd) : statusCd;
};

const dpBfStatus = {
  PROCESSING: "PROCESSING",
  ERROR: "ERROR",
  COMPLETED: "COMPLETED"
};

const dpApproveStatus = {
  INPROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  NOTSTARTED: "NOT_STARTED"
};

const dpTransformMeasure = {
  ACTUAL_SALES: "actualSales",
  ACTUAL_SALES_YOY: "salesActualYoY",
  FINANCE_PLAN: "financePlan",
  SALES_PLAN: "salesPlan",
  SALES_PLAN_MEASURE: "salesPlanMeasure",
  SALES_ORDER: "salesOrder",
  AVG_MEASURE: "avgSalesActual",
  POS_ACTUAL_SALES: "posActualSales",
  POS_ACTUAL_SALES_YOY: "posSalesActualYoY",
  POS_AVG_MEASURE: "posAvgSalesActual",
};

const dpPermission = [
  { id: "6", auth: "readWrite" },
  { id: "4", auth: "read" },
  { id: "2", auth: "write" },
  { id: "0", auth: "none" },
];

const dpMeasureType = {
  QTY: "QTY",
  AMT: "AMT",
  PRICE: "PRICE",
};

const dpChartType = {
  LINE: "LINE",
  BAR: "BAR",
  DASHED: "DASHED",
  // AREA 는 여기 없다 — WorkbenchUtil 이 "위 중 아무것도 아니면 AREA" 로 떨어뜨리는 구조라
  // 새 타입을 넣을 땐 반드시 이 상수와 WorkbenchUtil 분기를 같이 고쳐야 한다(안 그러면 조용히 AREA 가 된다).
};

const dpAccessControlTab = {
  CUSTHRCHY: "custHrchy",
  ITEMHRCHY: "itemHrchy",
  MEASURE: "measure",
  CUSTOMER: "customer",
  ITEM: "item",
};

const dpConfig = {
  BUCKET_UNIT: "BUCKET_UNIT",
  PLANNING_RANGE: "PLANNING_RANGE",
  DTF: "DTF",
  START_DAY: "START_DAY",
  PLAN_START_DATE: "PLAN_START_DATE",
  BF_PARAMETER: "BF_PARAMETER",
  ACCESS_CONTROL: "ACCESS_CONTROL",
  APPROVAL_ACCESS_CONTROL: "APPROVAL_ACCESS_CONTROL",
  RUN_BF: "RUN_BF",
  INITIAL_DEMAND: "INITIAL_DEMAND",
  HISTORY_SALES_RANGE: "HISTORY_SALES_RANGE",
  PLAN_ITEM: "PLAN_ITEM",
  ABC_XYZ: "ABC_XYZ",
  LR: "LR",
  DISAGGREGATION_TARGET: "DISAGGREGATION_TARGET",
  DEMAND_NETTING: "DEMAND_NETTING",
  APPLY_SNAPSHOT: "APPLY_SNAPSHOT",
  LEVEL_CONFIG: "LEVEL_CONFIG",
  BF_LEVEL_CONFIG: "BF_LEVEL_CONFIG",
  BF_VERSION: "BF_VERSION",
  NOTE_FLG: "NOTE_FLG",
  AVG_MONTHS: "AVG_MONTHS",
  AVG_FLG: "AVG_FLG",
  NPI_MAPPING_FLG: "NPI_MAPPING_FLG",
  POS_ACTUAL_FLG: "POS_ACTUAL_FLG",
  POS_AVG_FLG: "POS_AVG_FLG",
  POS_AVG_MONTHS: "POS_AVG_MONTHS",
};

/*
  v26.10: POS(판매시점 실적) 미출시. false 인 동안 POS 를 켜거나 고르는 UI 를 전부 내린다 —
  BF Settings 의 POS 토글, 버전·시나리오의 POS 평균 체크박스, 계산 대상의 POS_QTY, 변환 이력 라벨.
  POS_ACTUAL_FLG 로 이미 걸려 있는 화면은 플래그가 기본 OFF 라 따로 손대지 않았다.
  백엔드 짝: ImportSchemaService / transform_schema.json / BulkImportService / PlanVersionService 의 v26.10 주석.
*/
const SHOW_POS = false;

/*
  v26.10: Channel Planning 미출시. false 인 동안 채널용 마스터 열을 화면(그리드·엑셀·고급 필터)에서 내린다 —
  품목계층·거래처-품목의 목표재고일수(target_inv_days), 재고 실적의 거래처(customer_id) 열과 거래처 검색.
  DB 열과 Import 는 그대로라 값은 보존된다. 백엔드 짝: bulkinsert Column.exportHidden(ItemHrchy/CustomerItem/InventoryTxn).
*/
const SHOW_CHANNEL = false;

const dpABCConfig = ["AX", "AY", "AZ", "BX", "BY", "BZ", "CX", "CY", "CZ"];

const dpP13N = {
  DP_WORKBENCH_ETC: "DP_WORKBENCH_ETC",
  DP_WORKBENCH: "DP_WORKBENCH",
  DP_WORKBENCH_COMMON: "DP_WORKBENCH_COMMON",
  DP_WORKBENCH_ORDER_ITEM: "DP_WORKBENCH_ORDER_ITEM",
  DP_ACTUAL_PLAN_ORDER_ITEM: "DP_ACTUAL_PLAN_ORDER_ITEM",
  DP_ACTUAL_PLAN_CUM_ORDER_ITEM: "DP_ACTUAL_PLAN_CUM_ORDER_ITEM",
  DP_ACTUAL_PLAN: "DP_ACTUAL_PLAN",
  DP_CHANNEL_WORKBENCH: "CHANNEL_WORKBENCH",
  DP_CHANNEL_WORKBENCH_ETC: "CHANNEL_WORKBENCH_ETC",
  DP_CHANNEL_WORKBENCH_ORDER_ITEM: "CHANNEL_WORKBENCH_ORDER_ITEM",
};

const dpPlanDisableMeasures = {
  "PLAN_VS_ACTUAL_PRO": "planVsActProfit",
  "PLAN_VS_ACTUAL_P": "planAchievePerProfit",
  "FIN_VS_ACTUAL_PRO": "finVsActProfit",
  "FIN_VS_ACTUAL_P": "finAchievePerProfit",
}

const dpPlanActualMeasures = {
  SA_AMT: {
    name: dpMeasure.SA_AMT.name,
    type: toggleType.AMT,
  },
  YOY_AMT: {
    name: dpMeasure.YOY_AMT.name,
    type: toggleType.AMT,
  },
  BF_AMT: {
    name: dpMeasure.BF_AMT.name,
    type: toggleType.AMT,
  },
  COST: {
    name: dpMeasure.COST.name,
    type: toggleType.AMT,
  },
  SA_QTY: {
    name: dpMeasure.SA_QTY.name,
    type: toggleType.QTY,
  },
  YOY_QTY: {
    name: dpMeasure.YOY_QTY.name,
    type: toggleType.QTY,
  },
  BF_QTY: {
    name: dpMeasure.BF_QTY.name,
    type: toggleType.QTY,
  },
  DEMAND_PLAN_Q: {
    name: "demandPlanQty",
    type: toggleType.QTY,
    cd: dpMeasure.MF_QTY.cd
  },
  DEMAND_PLAN_A: {
    name: "demandPlanAmt",
    type: toggleType.AMT,
    cd: dpMeasure.MF_AMT.cd
  },
  PLAN_ACHIEVE_P_Q: {
    name: "planAchievePerQty",
    type: toggleType.QTY,
  },
  PLAN_ACHIEVE_P_A: {
    name: "planAchievePerAmt",
    type: toggleType.AMT,
  },
  FIN_ACHIEVE_P_Q: {
    name: "finAchievePerQty",
    type: toggleType.QTY,
  },
  FIN_ACHIEVE_P_A: {
    name: "finAchievePerAmt",
    type: toggleType.AMT,
  },
  BF_ACHIEVE_P_Q: {
    name: "bfAchievePerQty",
    type: toggleType.QTY,
  },
  BF_ACHIEVE_P_A: {
    name: "bfAchievePerAmt",
    type: toggleType.AMT,
  },
  PLAN_VS_ACT_QTY: {
    name: "planVsActQty",
    type: toggleType.QTY,
  },
  PLAN_VS_ACT_AMT: {
    name: "planVsActAmt",
    type: toggleType.AMT,
  },
  FIN_VS_ACT_QTY: {
    name: "finVsActQty",
    type: toggleType.QTY,
  },
  FIN_VS_ACT_AMT: {
    name: "finVsActAmt",
    type: toggleType.AMT,
  },
  BF_VS_ACT_Q: {
    name: "bfVsActQty",
    type: toggleType.QTY,
    cd: "BF_VS_ACT_QTY"
  },
  BF_VS_ACT_A: {
    name: "bfVsActAmt",
    type: toggleType.AMT,
    cd: "BF_VS_ACT_AMT"
  },
  BUDGET_PLAN_Q: {
    name: "budgetPlanQty",
    type: toggleType.QTY,
    cd: dpMeasure.FF_QTY.cd
  },
  BUDGET_PLAN_A: {
    name: "budgetPlanAmt",
    type: toggleType.AMT,
    cd: dpMeasure.FF_AMT.cd
  },
  GROSS_PROFIT: {
    name: "salesActualProfit",
    type: toggleType.AMT,
  },
  PLAN_PROFIT: {
    name: "demandPlanGP",
    type: toggleType.AMT,
  },
  FIN_PROFIT: {
    name: "budgetPlanGP",
    type: toggleType.AMT,
  },
  PLAN_VS_ACTUAL_PRO: {
    name: "planVsActProfit",
    type: toggleType.AMT,
  },
  FIN_VS_ACTUAL_PRO: {
    name: "finVsActProfit",
    type: toggleType.AMT,
  },
  GROSS_MARGIN_P: {
    name: "salesActualGPPer",
    type: toggleType.AMT,
  },
  PLAN_VS_ACTUAL_P: {
    name: "planAchievePerProfit",
    type: toggleType.AMT,
  },
  FIN_VS_ACTUAL_P: {
    name: "finAchievePerProfit",
    type: toggleType.AMT,
  },
};

const getDpPlanActualAlertMeasures = () => {
  const {
    SA_AMT, YOY_AMT, DEMAND_PLAN_A, BF_AMT,
    BUDGET_PLAN_A, GROSS_PROFIT, PLAN_PROFIT, FIN_PROFIT,
    SA_QTY, YOY_QTY, BF_QTY, DEMAND_PLAN_Q, BUDGET_PLAN_Q,
  } = dpPlanActualMeasures;
  return {
    SA_AMT, YOY_AMT, DEMAND_PLAN_A, BF_AMT,
    BUDGET_PLAN_A, GROSS_PROFIT, PLAN_PROFIT, FIN_PROFIT,
    SA_QTY, YOY_QTY, BF_QTY, DEMAND_PLAN_Q, BUDGET_PLAN_Q,
  }
}

const dpTrackingMeasures = [
  dpMeasure.SA_QTY,
  dpMeasure.SA_AMT,
  dpMeasure.MF_AMT,
  dpMeasure.MF_QTY,
  dpMeasure.SF_AMT,
  dpMeasure.SF_QTY,
  dpMeasure.MK_AMT,
  dpMeasure.MK_QTY,
  dpMeasure.BF_QTY,
  dpMeasure.BF_AMT
]

const bfMetric = ['MAPE','WAPE','RMSE'];

const bfAlgorithm = {
  ZTFM: {cd: "ZTFM", name: "TimesFM", seq: 1},
  PR: {cd: "PR", name: "Prophet", seq: 2},
  RF: {cd: "RF", name: "Random Forest", seq: 3},
  XGB: {cd: "XGB", name: "GBM", seq: 4},
  ZBASE: {cd: "ZBASE", name: "Baseline", seq: 5},
  ZSMA: {cd: "ZSMA", name: "ZSMA", seq: 6},
  SMA: {cd: "SMA", name: "SMA", seq: 7},
  CRST: {cd: "CRST", name: "Croston", seq: 8},
  AR: {cd: "AR", name: "Auto ARIMA", seq: 9},
  HW: {cd: "HW", name: "Holt-Winters", seq: 10},
}

const customer = { id: 1, cd: "CUSTOMER", name: "Customer", seqNum: 99 };
const item = { id: 2, cd: "ITEM", name: "Item", seqNum: 99 };

/*
 * includeChannelSources — 채널(POS_QTY/POS_YOY_QTY/POS_SA_QTY, 그리고 그 위에서만 의미가 있는
 * SUGGESTED_MP_QTY)를 Compute Setting의 소스 후보로 보여줄지. BF Source Data(POS 실적을 BF에
 * 반영하는 옵션, DP Settings의 POS_ACTUAL_FLG)가 꺼져 있으면 POS 계열 데이터 자체를 안 쓰기로
 * 한 것이므로, 이 소스들을 후보에서 뺀다(호출측이 isChannel && posActualFlg 를 넘겨준다).
 */
const getSourceMeasureList = (oriMeasureList, initialValue, includeChannelSources) => {
  const { LAST_ACTUAL_SALES, ACTUAL_SALES_YOY, LAST_RELEASED_VERSION, FINANCE_PLAN, SALES_PLAN_MEASURE, DP_VERSION, MEASURE_CUSTOM } = dpInitalValues;
  const { BASELINE_FORECAST } = dpSettingCode;
  const { MF_AMT, MF_QTY, SF_QTY, SF_AMT, BF_QTY, SA_QTY, SA_AMT, YOY_QTY, YOY_AMT, FF_QTY, FF_AMT,
    SALES_PLAN_QTY, SALES_PLAN_AMT, SUGGESTED_MP_QTY, POS_QTY, POS_YOY_QTY, POS_SA_QTY } = dpMeasure;

  if (initialValue === LAST_RELEASED_VERSION || initialValue === DP_VERSION) {
    return oriMeasureList.filter(item => item.measureCd === MF_QTY.cd || item.measureCd === MF_AMT.cd
      || item.measureCd === SF_QTY.cd || item.measureCd === SF_AMT.cd);
  } else if (initialValue === BASELINE_FORECAST) {
    return oriMeasureList.filter(item => item.measureCd === BF_QTY.cd);
  } else if (initialValue === LAST_ACTUAL_SALES) {
    return oriMeasureList.filter(item => item.measureCd === SA_QTY.cd || item.measureCd === SA_AMT.cd);
  } else if (initialValue === ACTUAL_SALES_YOY) {
    return oriMeasureList.filter(item => item.measureCd === YOY_QTY.cd || item.measureCd === YOY_AMT.cd);
  } else if (initialValue === FINANCE_PLAN) {
    return oriMeasureList.filter(item => item.measureCd === FF_QTY.cd || item.measureCd === FF_AMT.cd);
  } else if (initialValue === SALES_PLAN_MEASURE) {
    return oriMeasureList.filter(item => item.measureCd === SALES_PLAN_QTY.cd || item.measureCd === SALES_PLAN_AMT.cd);
  } else if (initialValue === MEASURE_CUSTOM) {
    const measure = oriMeasureList.filter(item => item.measureCd === MF_QTY.cd || item.measureCd === SF_QTY.cd || item.measureCd === BF_QTY.cd || item.measureCd === SA_QTY.cd || item.measureCd === YOY_QTY.cd
      || item.measureCd === FF_QTY.cd || item.measureCd === SALES_PLAN_QTY.cd
      || (includeChannelSources && (item.measureCd === POS_QTY.cd || item.measureCd === POS_YOY_QTY.cd || item.measureCd === POS_SA_QTY.cd)));
    if (includeChannelSources) {
      measure.push({ ...SUGGESTED_MP_QTY, measureCd: SUGGESTED_MP_QTY.cd });
    }
    return measure;
  }
  return oriMeasureList;
};

/*
  ABC-XYZ
 */

const HIGH_VOLUMES = "highVolumes";
const MIDDLE_VOLUMES = "middleVolumes";
const LOW_VOLUMES = "lowVolumes";
const STABLES = "stables";
const FLUCTUATING = "fluctuating";
const VERY_FLUCTUATING = "veryFluctuating";

const ABCClassConfig = {
  A: {style: { backgroundColor: "#7FC650" }},
  B: {style: { backgroundColor: "#FFD56F" }},
  C: {style: { backgroundColor: "#FF7B54" }},
  X: {style: { backgroundColor: "#7FC650" }},
  Y: {style: { backgroundColor: "#FFD56F" }},
  Z: {style: { backgroundColor: "#FF7B54" }},
  AX: { className: "high-stables", uncertainty: STABLES, volume: HIGH_VOLUMES, style: { backgroundColor: "#7FC650" } },
  AY: { className: "high-fluctuating", uncertainty: FLUCTUATING, volume: HIGH_VOLUMES, style: { backgroundColor: "#C4E27F" } },
  AZ: { className: "high-very-fluctuating", uncertainty: VERY_FLUCTUATING, volume: HIGH_VOLUMES, style: { backgroundColor: "#FFD56F" } },
  BX: { className: "high-fluctuating", uncertainty: STABLES, volume: MIDDLE_VOLUMES, style: { backgroundColor: "#C4E27F" } },
  BY: { className: "high-very-fluctuating", uncertainty: FLUCTUATING, volume: MIDDLE_VOLUMES, style: { backgroundColor: "#FFD56F" } },
  BZ: { className: "low-fluctuating", uncertainty: VERY_FLUCTUATING, volume: MIDDLE_VOLUMES, style: { backgroundColor: "#FFB26B" } },
  CX: { className: "high-very-fluctuating", uncertainty: STABLES, volume: LOW_VOLUMES, style: { backgroundColor: "#FFD56F" } },
  CY: { className: "low-fluctuating", uncertainty: FLUCTUATING, volume: LOW_VOLUMES, style: { backgroundColor: "#FFB26B" } },
  CZ: { className: "low-very-fluctuating", uncertainty: VERY_FLUCTUATING, volume: LOW_VOLUMES, style: { backgroundColor: "#FF7B54" } }
};

const displayDigit = 2;

/*
  IP
*/
const ipMeasure = {
  ACTIVE_SKU: "activeSkus",
  AVG_NO_OF_LOCATION: "avgNoOfLocation",
  INV_DAYS: "invDays",
  INV_TURNOVER: "invTurnover",
  SALES_AMT: "salesAmt",
  SALES_QTY: "salesQty",
  SKU: "skus",
  STOCK_AMT: "stockAmt",
  STOCK_QTY: "stockQty",
  // INV_AMT: "invAmt",
  // INV_QTY: "invQty",
  PROFIT: "profit",
  YOY_PER: "yoyPer",
  MOM_PER: "momPer",
};

const ipVersionStatusCode = {
  ...baseVersionStatusCode,
  NA: "NA",
  READY: "READY",
  STALE: "STALE",
  RELEASING: "RELEASING",
};

const classifiDimLCode = {
  ITEM: "item",
  CATEGORY: "category",
  LOCATION: "location",
  CATEGORY_LOCATION: "categoryLocation",
}

const classifiBaseCode = {
  QUANTITY: "quantity",
  REVENUE: "revenue",
  AMOUNT: "amount",
  PROFIT: "profit",
  FREQUENCY: "frequency",
  COGS: "cogs"
}

const calcType = {
  CV: "CV",
  FORECAST_GAP: "FORECAST_GAP",
}

const ipPolicyCd = {
  SD: "safetyDays",
  MAX_AVG: "maxSubtractAvg",
  NOR_DIST: "norDist",
  NOR_DIST_SUP: "norDistSup"
}

const ipSettings = {
  IP_SETTINGS_CONFIG_CD: "IP_SETTINGS_CONFIG",
  SIM_TARGET_FILTER_POLICY: "SIM_TARGET_FILTER_POLICY",
  SIM_TARGET_FILTER_ENABLED: "SIM_TARGET_FILTER_ENABLED",
  TARGET_LOCATION: "TARGET_LOCATION",
  LOCATION_NODE_TREE: "LOCATION_NODE_TREE",
  TARGET_ITEM_HRCHY: "TARGET_ITEM_HRCHY",
  ITEM_HRCHY_NODE_TREE: "ITEM_HRCHY_NODE_TREE"
}

/*
  RP
*/
const rpMeasure = {
  ACTIVE_SKU: "activeSkus",
  AVG_NO_OF_LOCATION: "avgNoOfLocation",
  INV_DAYS: "invDays",
  INV_TURNOVER: "invTurnover",
  SALES_AMT: "salesAmt",
  SKU: "skus",
  STOCK_AMT: "stockAmt",
  STOCK_QTY: "stockQty",
  // INV_AMT: "invAmt",
  // INV_QTY: "invQty",
  PROFIT: "profit",
  YOY_PER: "yoyPer",
  MOM_PER: "momPer",
  ACTUAL_ARRIVAL_QTY: "actualArrivalQty",
  ARRIVAL_QTY: "arrivalQty",
  // ARRIVAL_QTY_ADJ: "arrivalAdj",
  ARRIVAL_QTY_CFM: "arrivalQtyCfm",
  ARRIVAL_QTY_GAP: "arrivalQtyGap",
  ARRIVAL_QTY_GAP_PCT: "arrivalQtyGapPct",
  ARRIVAL_QTY_PLAN: "arrivalQtyPlan",
  ARRIVAL_AMT: "arrivalAmt",
  BOH: "boh",
  BOH_AMT: "bohAmt",
  DEMAND_QTY: "demandQty",
  DEMAND_AMT: "demandAmt",
  EOH: "eoh",
  EOH_AMT: "eohAmt",
  PLAN_ARRIVAL_QTY: "planArrivalQty",
  PLAN_ORDER_QTY: "planOrderQty",
  PURCHASE_AMT_CUM: "purchaseAmtCum",
  // PURCHASE_QTY: "purchaseQty",
  PURCHASE_PLAN_AMT: "purchasePlanAmt",
  PURCHASE_PLAN_QTY: "purchasePlanQty",
  PURCHASE_PLAN_QTY_ADJ: "purchasePlanQtyAdj",
  PURCHASE_ORDER_AMT: "purchaseOrderAmt",
  PURCHASE_ORDER_ACTUAL_AMT: "purchaseOrderActualAmt",
  // PURCHASE_ORDER_AMT_CUM: "purchaseOrderAmtCum",
  PURCHASE_BUDGET_AMT: "purchaseBudgetAmt",
  PURCHASE_BUDGET_AMT_CUM: "purchaseBudgetAmtCum",
  REPLENISH_PLAN_AMT: "replenishPlanAmt",
  REPLENISH_PLAN_QTY: "replenishPlanQty",
  REPLENISH_PLAN_QTY_ADJ: "replenishPlanQtyAdj",
  RP_ORDER: "rpOrder",
  // RP_ORDER_QTY: "rpOrderQty",
  // RP_ORDER_QTY_ADJ: "rpOrderQtyAdj",
  SALES_QTY: "salesQty",
  PROD_QTY: "prodQty",
  SHIPMENT_QTY: "shipmentQty",
  SHIPMENT_AMT: "shipmentAmt",
  SIM_ARRIVAL: "simArrival",
  SIM_EOH: "simEoh",
  SIM_BOH: "simBoh",
  SIM_DEMAND_QTY: "simDemandQty",
  SIM_RP_ORDER: "simRpOrder",
  SIM_SHIPMENT_QTY: "simShipmentQty",
  TARGET_STOCK: "targetStock",
  TARGET_STOCK_AMT: "targetInvAmt",
  ROP: "rop", // ReOrder Point
  CROSSOVER_RATIO: "crossoverRatio",
  EXP_INV_QTY: "expQty",
  EXP_INV_AMT: "expAmt",
  GROSS_PROFIT: "grossProfit",
  GROSS_MARGIN: "grossMargin",
  FCST_DEMAND_QTY: "fcstDemandQty",
  FCST_DEMAND_AMT: "fcstDemandAmt",
  INTERNAL_DEMAND_QTY: "internalDemandQty",
  INTERNAL_DEMAND_AMT: "internalDemandAmt",
  LAST_RELEASED_REPLENISHMENT_QTY: "lastReleasedReplenishmentQty",
  LAST_RELEASED_PURCHASE_QTY: "lastReleasedPurchaseQty",
  BACKORDER_QTY: "backorderQty",
  SIM_BACKORDER_QTY: "simBackorderQty",
  FILL_RATE_QTY: "fillRate",
  LOSS_OF_OPPORTUNITY: "lossOfOpportunity",
  DOWNSTREAM_DEMAND_QTY_SUM: "downstreamDemandQtySum",
  DOWNSTREAM_DEMAND_AMT_SUM: "downstreamDemandAmtSum",
  DOWNSTREAM_EOH_QTY_SUM: "downstreamEohQtySum",
  DOWNSTREAM_EOH_AMT_SUM: "downstreamEohAmtSum",
  KIT_FCST_DEMAND_QTY: "kitFcstDemandQty",
  KIT_FCST_DEMAND_AMT: "kitFcstDemandAmt",
  INV_COV_DAYS: "inventoryCoverageDays",
  SIM_INV_COV_DAYS: "simInventoryCoverageDays",
  SHIPMENT_QTY_CFM: "shipmentQtyCfm",
  SHIPMENT_QTY_PLAN: "shipmentQtyPlan",
  SHIPMENT_QTY_FCST: "shipmentQtyFcst",
  SHIPMENT_AMT_FCST: "shipmentAmtFcst",
  SHIPMENT_QTY_REPL: "shipmentQtyRepl",
  SHIPMENT_AMT_REPL: "shipmentAmtRepl",
  // SHIPMENT_QTY_TOTAL: "shipmentQtyTotal",
  // SHIPMENT_AMT_TOTAL: "shipmentAmtTotal",
  LAST_YEAR_INV_QTY: "lastYearInvQty",
  LAST_YEAR_INV_AMT: "lastYearInvAmt",
  LAST_YEAR_SALES_QTY: "lastYearSalesQty",
  LAST_YEAR_SALES_AMT: "lastYearSalesAmt",
  LAST_YEAR_GROSS_PROFIT: "lastYearGrossProfit",
  SHIPMENT_SHORTAGE_QTY: "shipmentShortageQty"
};

const rpPolicyCd = {
  P_SYSTEM: "pSystem",
  Q_SYSTEM: "qSystem",
  MIN_MAX_SYSTEM: "minMaxSystem",
  BASE_STOCK_SYSTEM: "baseStockSystem"
}

const rpVersionStatusCode = {
  ...baseVersionStatusCode,
  SIMULATION: "SIMULATION"
}

const rpDemandDistributionPolicy = {
  EQUAL_BY_BUCKET: "eqaulByBucket",
  LAST_OF_BUCKET: "lastOfBucket"
}

const inventoryCoverageDaysPolicy = {
  INV_COV_DAYS_THRESHOLD: "invCovDaysThreshHold",
  INV_COV_DAYS_APPLY: "invCovDaysApply",
  INV_COV_DAYS_COMPUTED_METHOD: "invCovComputedMethod",
}

/*
  MP
*/

const datePriorityNameByCode = {
  DUE_DATE: "dueDate",
  W_DUE_DATE: "weekOfDueDate",
  M_DUE_DATE: "monthOfDueDate",
  PLAN_HORIZON: "planHorizon"
}

const timeColumnDecimalLimit = 5;

const mpVersionStatusCode = {
  ...baseVersionStatusCode,
  UNPLANNED: "UNPLANNED",
  PLANNED: "PLANNED"
}

const mpDemandType = {
  FORECAST: "demandPlanType",
  REPLENISHMENT: "replenishmentPlan",
  PRODORDER: "productionOrder"
}

const mpMeasure = {
  BOH: "boh",
  BACKORDER_QTY: "backorderQty",
  DEMAND_QTY: "demandQty",
  PRODUCTION_PLAN: "productionPlan",
  SHIPMENT_QTY: "shipmentQty",
  EOH: "eoh",
  GROSS_REQ: "grossReq",
  SCHEDULED_RECEIPTS: "scheduledReceipts",
  PROJ_ON_HAND: "projOnhand",
  NET_REQ: "netReq",
  PO_RECEIPTS: "poReceipts",
  PO_RELEASES: "poReleases",
  CAPA_TOTAL: "capaTotal",
  CAPA_OVER_TOTAL: "capaOverTotal",
  CAPA_LOAD: "capaLoad",
  CAPA_SETUP: "capaSetup",
  CAPA_OVER: "capaOver",
  CAPA_AVAIL: "capaAvail",
  CAPA_UTIL: "capaUtil",
  LIMIT_UTIL_RATE: "limitUtilRate",
  SIM_BOH: "simBoh",
  SIM_BACKORDER_QTY: "simBackorderQty",
  SIM_DEMAND_QTY: "simDemandQty",
  SIM_PRODUCTION_PLAN: "simProdQty",
  SIM_SUPPLY_QTY: "simSupplyQty",
  SIM_EOH: "simEoh",
  SUPPLY_QTY: "supplyQty",
  TARGET_INV_QTY: "targetInvQty",
};

const mpTimeUom = ["seconds", "minutes", "hours", "days"]

const mpTimeBase = ["unit", "lot"]

const planStrategies = {
  forWard: "forward",
  forWard2: "forward2",
  backWard: "backward"
}

const orderStatusCode = {
  ON_TIME: "ON_TIME",
  DELAY: "DELAY",
  SHORT: "SHORT"
}

const priorityItems = {
  DATE_PRIORITY: {
    DUE_DATE: "DUE_DATE",
    W_DUE_DATE: "W_DUE_DATE",
    M_DUE_DATE: "M_DUE_DATE",
    PLAN_HORIZON: "PLAN_HORIZON",
  },
  DEMAND_PRIORITY: {
    DUE_DATE: {
      name: "dueDate",
      sorting: "asc",
      seq: 0,
    },
    STD_UNIT_PRICE: {
      name: "stdSalesPrice",
      sorting: "desc",
      seq: 1,
    },
    SALES_UNIT_COST: {
      name: "salesUnitCost",
      sorting: "asc",
      seq: 2,
    },
    INV_UNIT_COST: {
      name: "invUnitCost",
      sorting: "asc",
      seq: 3,
    },
    DEMAND_QTY: {
      name: "demandQuantity",
      sorting: "desc",
      seq: 4,
    },
    ITEM: {
      name: "itemPriority",
      sorting: "asc",
      seq: 5,
    },
    CUSTOMER: {
      name: "customerPriority",
      sorting: "asc",
      seq: 6,
    },
    PLAN_ORDER: {
      name: "planOrder",
      sorting: "asc",
      seq: 7,
    },
    URGENT: {
      name: "urgent",
      sorting: "asc",
      seq: 8,
    },
    // Demand Netting - 확정 수주와 잔여 예측. 네팅을 안 쓰는 테넌트는 수요 유형이
    // 빈 값이라 이 둘을 켜도 정렬이 바뀌지 않는다.
    // v26.10: 네팅 미출시 — MP Settings·AI MP 시나리오가 이 목록을 파생하므로 여기서 함께 내린다.
    // SALES_ORDER: {
    //   name: "salesOrder",
    //   sorting: "asc",
    //   seq: 9,
    // },
    // REMAIN_FCST: {
    //   name: "remainFcst",
    //   sorting: "asc",
    //   seq: 10,
    // }
  },
  PRODUCTION_PRIORITY: {
    FAST: "fast",
    PRIORITY: "priority",
    MASTER_DATA: "masterData",
  }
}

const mpPlanConfig = {
  MC: { code: "MC", name: "materialConst" },
  PS: { code: "PS", name: "planStrategy" },
  RC: { code: "RC", name: "resourceCapacity" },
  BACKORDER: { code: "BACKORDER", name: "backorder" },
  DATE_PRIORITY: { code: "DATE_PRIORITY", name: "datePriority" },
  FROZEN_RANGE: { code: "FROZEN_RANGE", name: "frozenRange" },
  DEMAND_PRIORITY: { code: "DEMAND_PRIORITY", name: "demandPriority"},
  SAFETY_STOCK_POLICY: { code: "SAFETY_STOCK_POLICY", name: "safetyStockPolicy" },
  KIT_PLAN_MODE: { code: "KIT_PLAN_MODE", name: "planningTargetItemType" },
  ALLOW_SEMI_ORDER: { code: "ALLOW_SEMI_ORDER", name: "sfgOrder" },
  // USE_DP_DEMAND: { code: "USE_DP_DEMAND", name: "useDpDemand" },
  ALT_RES_POLICY: { code: "ALT_RES_POLICY", name: "altResPolicy" },
}

/*
  ALL
 */
const dashboardTitle = {
  SALES: "sales",
  GROSS_PROFIT: "grossProfit",
  PURCHASE: "purchase",
  INVENTORY: "inventory"
}
const dashboardMeasures = {
  [dashboardTitle.SALES]: {
    ACT_SALES_AMT: {
      name: "actSaleAmt", type: toggleType.AMT,
      series: { type: toggleType.BAR, groupName: toggleType.AMT },
      cumSeries: { type: toggleType.AREA, groupName: toggleType.AMT, isDefault: true }
    },
    PLAN_SALES_AMT: {
      name: "planSaleAmt", type: toggleType.AMT,
      series: { type: toggleType.BAR, groupName: toggleType.AMT },
      cumSeries: { type: toggleType.LINE, groupName: toggleType.AMT, isDefault: true }
    },
    FIN_SALES_AMT: {
      name: "finanSaleAmt", type: toggleType.AMT,
      series: { type: toggleType.BAR, groupName: toggleType.AMT },
      cumSeries:  { type: toggleType.LINE, groupName: toggleType.AMT, isDefault: true }
    },
    LAND_SALES_AMT: {
      name: "landSaleAmt", type: toggleType.AMT,
      series: { type: toggleType.LINE, groupName: toggleType.AMT, isDefault: true },
    },
  },
  [dashboardTitle.GROSS_PROFIT]: {
    ACT_GROSS_PROFIT: {
      name: "actGroProfit", type: toggleType.AMT,
      series: { type: toggleType.BAR, groupName: toggleType.AMT },
      cumSeries: { type: toggleType.AREA, groupName: toggleType.AMT, isDefault: true }
    },
    PLAN_GROSS_PROFIT: {
      name: "demandPlanGP", type: toggleType.AMT,
      series: { type: toggleType.BAR, groupName: toggleType.AMT },
      cumSeries: { type: toggleType.LINE, groupName: toggleType.AMT, isDefault: true }
    },
    FIN_GROSS_PROFIT: {
      name: "finanGroProfit", type: toggleType.AMT,
      series: { type: toggleType.BAR, groupName: toggleType.AMT },
      cumSeries: { type: toggleType.LINE, groupName: toggleType.AMT, isDefault: true }
    },
    LAND_GROSS_PROFIT: {
      name: "landGroProfit", type: toggleType.AMT,
      series: { type: toggleType.LINE, groupName: toggleType.AMT, isDefault: true },
    },
  },
  [dashboardTitle.PURCHASE]: {
    ACT_PC_AMT: {
      name: "actPcAmt", type: toggleType.AMT,
      series: { type: toggleType.BAR, groupName: toggleType.AMT },
      cumSeries: { type: toggleType.AREA, groupName: toggleType.AMT, isDefault: true },
    },
    PLAN_PC_AMT: {
      name: "purchasePlanAmt", type: toggleType.AMT,
      series: { type: toggleType.BAR, groupName: toggleType.AMT },
      cumSeries: { type: toggleType.LINE, groupName: toggleType.AMT, isDefault: true }
    },
    PC_BUDGET_AMT: {
      name: "purchaseBudgetAmt", type: toggleType.AMT,
      series: { type: toggleType.LINE, groupName: toggleType.AMT, isDefault: true },
      cumSeries: { type: toggleType.LINE, groupName: toggleType.AMT, isDefault: true }
    },
    PLAN_FILL_RATE: {
      name: "planFillRate", type: toggleType.AMT,
      series: { type: toggleType.LINE, groupName: "percent" },
    },
    BUDGET_FILL_RATE: {
      name: "budgetFillRate", type: toggleType.AMT,
      series: { type: toggleType.LINE, groupName: "percent" },
    },
  },
  [dashboardTitle.INVENTORY]: {
    ACT_STOCK_QTY: {
      name: "actStockQty", type: toggleType.QTY,
      series: { type: toggleType.LINE, groupName: toggleType.QTY },
    },
    PLAN_STOCK_QTY: {
      name: "planStockQty", type: toggleType.QTY,
      series: { type: toggleType.LINE, groupName: toggleType.QTY },
    },
    TARGET_INV_QTY: {
      name: "targetInvQty", type: toggleType.QTY,
      series: { type: toggleType.LINE, groupName: toggleType.QTY },
    },
    ACT_STOCK_AMT: {
      name: "actStockAmt", type: toggleType.AMT,
      series: { type: toggleType.LINE, groupName: toggleType.AMT, isDefault: true },
    },
    PLAN_STOCK_AMT: {
      name: "planStockAmt", type: toggleType.AMT,
      series: { type: toggleType.LINE, groupName: toggleType.AMT, isDefault: true },
    },
    TARGET_INV_AMT: {
      name: "targetInvAmt", type: toggleType.AMT,
      series: { type: toggleType.LINE, groupName: toggleType.AMT, isDefault: true },
    },
    ACT_INV_TURNOVER: {
      name: "actInvTurnover", type: toggleType.AMT,
      series: { type: toggleType.LINE, groupName: "turnRatio", isDefault: true },
    },
    PLAN_INV_TURNOVER: {
      name: "planInvTurnover", type: toggleType.AMT,
      series: { type: toggleType.LINE, groupName: "turnRatio", isDefault: true },
    },
  },
}

const dashboardMeasure = {
  [dashboardTitle.SALES]: values(dashboardMeasures[dashboardTitle.SALES]).map(item => item.name),
  [dashboardTitle.GROSS_PROFIT]: values(dashboardMeasures[dashboardTitle.GROSS_PROFIT]).map(item => item.name),
  [dashboardTitle.PURCHASE]: values(dashboardMeasures[dashboardTitle.PURCHASE]).map(item => item.name),
  [dashboardTitle.INVENTORY]: values(dashboardMeasures[dashboardTitle.INVENTORY]).map(item => item.name),
};

const ipRpMeasure = {
  ...ipMeasure,
  ...rpMeasure
};

const ipRpMpMeasure = {
  ...ipMeasure,
  ...rpMeasure,
  ...mpMeasure
};

const versionStatusCode = {
  ...dpVersion,
  ...ipVersionStatusCode,
  ...rpVersionStatusCode,
  ...mpVersionStatusCode,
  UNPLANNED: "UNPLANNED",
  RUNNING: "RUNNING",
  PLANNED: "PLANNED",
  FAILED: "FAILED",
  RELEASED: "RELEASED",
}

/*
  OTHER
*/
const scheduleTargetObj = {
  DATA_TRANSFORM_IP: "dataTransformIP",
  DATA_TRANSFORM_DP_REF: "dataTransformDPRef",
  DATA_TRANSFORM_RP_MEASURE: "dataTransformRPDemand",
  INVENTORY_PLAN: "inventoryPlan",
  REPLENISHMENT_PLAN: "replenishmentPlan",
  DEMAND_PLAN: "demandPlan",
}

const scheduleStatusObj = {
  STATUS_RUNNING:"running",
  STATUS_SUCCESS:"success",
  STATUS_WARNING: "warning",
  STATUS_FAIL:"fail",
  STATUS_FAILURE:"failure",
  STATUS_STOP:"stop",
  STATUS_IDLE:"idle"
}

const deleteInsertTables = {
    salesTransaction: "TXN_DATE",
    inventoryTransaction: "TXN_DATE",
    intransitInventory: "BASE_DATE",
    shipmentTransaction: "ATD"
};

const deleteTables = {
  ...deleteInsertTables,
  financePlan: "DUE_DATE",
  salesPlan: "DUE_DATE",
  salesOrder: "DUE_DATE",
  prodOrder: "DUE_DATE",
  exchangeRate: "BASE_DATE",
  unitPrice: "BASE_DATE",
  purchaseBudget: "BASE_DATE",
  materialReceiptPlan: "BASE_DATE",
  bfFeatureDate: "BASE_DATE",
  bfFeatureSales: "BASE_DATE",
  menuPurchaseOrder: "DUE_DATE",
  wip: "PROD_DATE",
  menuResourceCapacity: "OVERLAP_DATE"
};

const workbenchAlertObjs = {
  REFER_MEASURE: "referenceMeasure",
  TARGET_MEASURE: "targetMeasure",
  UPPER_THRESHOLD: "upperThreshold",
  LOWER_THRESHOLD: "lowerThreshold",
}

/* CHART CURRENCY 표시할 MEASURE*/
const amtCurrencyMeasure = [
    /*RP*/
  rpMeasure.BOH_AMT,
  rpMeasure.DEMAND_AMT,
  rpMeasure.EOH_AMT,
  rpMeasure.ARRIVAL_AMT,
  rpMeasure.PURCHASE_PLAN_AMT,
  rpMeasure.PURCHASE_ORDER_ACTUAL_AMT,
  rpMeasure.PURCHASE_ORDER_AMT,
  rpMeasure.PURCHASE_BUDGET_AMT,
  rpMeasure.REPLENISH_PLAN_AMT,
  rpMeasure.SHIPMENT_AMT,
  rpMeasure.TARGET_STOCK_AMT,
  rpMeasure.EXP_INV_AMT,
  rpMeasure.GROSS_PROFIT,
  rpMeasure.FCST_DEMAND_AMT,
  rpMeasure.INTERNAL_DEMAND_AMT,
  rpMeasure.KIT_FCST_DEMAND_AMT,
  rpMeasure.DOWNSTREAM_DEMAND_AMT_SUM,
  rpMeasure.DOWNSTREAM_EOH_AMT_SUM,
  rpMeasure.PURCHASE_AMT_CUM,
  rpMeasure.LAST_YEAR_SALES_AMT,
  rpMeasure.LAST_YEAR_INV_AMT,
  rpMeasure.LAST_YEAR_GROSS_PROFIT,
  rpMeasure.SHIPMENT_AMT_REPL,
  rpMeasure.SHIPMENT_AMT_FCST,
  "shipmentAmtTotal",
  "totalInvAmt",
  "expectedExpAmt",
    /*DP*/
  dpMeasure.ASA_AMT.name,
  dpMeasure.BF_AMT.name,
  dpMeasure.COGS.name,
  dpMeasure.COST.name,
  dpMeasure.FF_AMT.name,
  dpMeasure.LR_AMT.name,
  dpMeasure.MF_AMT.name,
  dpMeasure.SF_AMT.name,
  dpMeasure.SA_AMT.name,
  dpMeasure.YOY_AMT.name,
  dpMeasure.MK_AMT.name,
  dpMeasure.PROFIT.name,
  dpMeasure.ASA_AMT.cd,
  dpMeasure.BF_AMT.cd,
  dpMeasure.COGS.cd,
  dpMeasure.COST.cd,
  dpMeasure.FF_AMT.cd,
  dpMeasure.LR_AMT.cd,
  dpMeasure.MF_AMT.cd,
  dpMeasure.SF_AMT.cd,
  dpMeasure.SA_AMT.cd,
  dpMeasure.YOY_AMT.cd,
  dpMeasure.MK_AMT.cd,
  dpMeasure.PROFIT.cd,
  /*IP*/
  ipMeasure.SALES_AMT,
  ipMeasure.STOCK_AMT,
  "invAmt",
  ipMeasure.PROFIT,
  "avgSalesMonthlyAmt",
  "totalSalesAmt",
  "avgStockMonthlyAmt",
  "avgInvMonthlyAmt",
  /*Dashboard*/
  ...dashboardMeasure.sales,
  ...dashboardMeasure.grossProfit,
  "actPcAmt",
  "purchasePlanAmt",
  "landPcAmt",
  "actStockAmt",
  "planStockAmt",
  "targetInvAmt",
  "actPcAmtCum",
  "purchasePlanAmtCum",
  "purchaseBudgetAmtCum",
  "landPcAmtCum",
  "actGroProfitCum",
  "demandPlanGPCum",
  "finanGroProfitCum",
  "planSaleAmtCum",
  "actSaleAmtCum",
  "finanSaleAmtCum"
];

const rpReviewMeasures = [
  rpMeasure.BOH, rpMeasure.BOH_AMT, rpMeasure.DEMAND_QTY,
  rpMeasure.DEMAND_AMT, rpMeasure.KIT_FCST_DEMAND_QTY, rpMeasure.KIT_FCST_DEMAND_AMT, rpMeasure.FCST_DEMAND_QTY, rpMeasure.FCST_DEMAND_AMT, rpMeasure.INTERNAL_DEMAND_QTY, rpMeasure.INTERNAL_DEMAND_AMT,
  rpMeasure.DOWNSTREAM_DEMAND_QTY_SUM, rpMeasure.DOWNSTREAM_DEMAND_AMT_SUM, rpMeasure.DOWNSTREAM_EOH_QTY_SUM, rpMeasure.DOWNSTREAM_EOH_AMT_SUM,
  rpMeasure.BACKORDER_QTY, rpMeasure.REPLENISH_PLAN_QTY,
  rpMeasure.REPLENISH_PLAN_AMT, rpMeasure.PURCHASE_PLAN_QTY,
  rpMeasure.PURCHASE_PLAN_AMT, rpMeasure.ARRIVAL_QTY,
  rpMeasure.ARRIVAL_QTY_PLAN, rpMeasure.ARRIVAL_QTY_CFM, rpMeasure.ARRIVAL_AMT,
  rpMeasure.SHIPMENT_QTY, rpMeasure.SHIPMENT_QTY_PLAN, rpMeasure.SHIPMENT_QTY_CFM, rpMeasure.SHIPMENT_AMT, rpMeasure.SHIPMENT_QTY_FCST,  rpMeasure.SHIPMENT_AMT_FCST, rpMeasure.SHIPMENT_QTY_REPL,  rpMeasure.SHIPMENT_AMT_REPL,
  rpMeasure.PROD_QTY,
  rpMeasure.TARGET_STOCK, rpMeasure.TARGET_STOCK_AMT, rpMeasure.ROP, rpMeasure.EXP_INV_QTY,
  rpMeasure.EXP_INV_AMT, rpMeasure.EOH, rpMeasure.EOH_AMT, rpMeasure.INV_COV_DAYS, rpMeasure.SHIPMENT_SHORTAGE_QTY
];

const defaultRpReviewMeasures = [
  rpMeasure.BOH, rpMeasure.DEMAND_QTY, rpMeasure.BACKORDER_QTY, rpMeasure.REPLENISH_PLAN_QTY,
  rpMeasure.PURCHASE_PLAN_QTY, rpMeasure.ARRIVAL_QTY, rpMeasure.ARRIVAL_QTY_PLAN, rpMeasure.ARRIVAL_QTY_CFM,
  rpMeasure.SHIPMENT_QTY, rpMeasure.TARGET_STOCK, rpMeasure.ROP, rpMeasure.EOH
];

const psiSimulationMeasures = [
  rpMeasure.DEMAND_QTY,  rpMeasure.KIT_FCST_DEMAND_QTY,  rpMeasure.FCST_DEMAND_QTY, rpMeasure.INTERNAL_DEMAND_QTY,
  rpMeasure.DOWNSTREAM_DEMAND_QTY_SUM, rpMeasure.DOWNSTREAM_EOH_QTY_SUM,
  rpMeasure.BACKORDER_QTY, rpMeasure.RP_ORDER,
  rpMeasure.ARRIVAL_QTY, rpMeasure.ARRIVAL_QTY_PLAN,
  rpMeasure.ARRIVAL_QTY_CFM, rpMeasure.SHIPMENT_QTY, rpMeasure.SHIPMENT_QTY_PLAN, rpMeasure.SHIPMENT_QTY_CFM,
  rpMeasure.SHIPMENT_QTY_FCST, rpMeasure.SHIPMENT_QTY_REPL,
  rpMeasure.BOH, rpMeasure.EOH, rpMeasure.INV_COV_DAYS, rpMeasure.SHIPMENT_SHORTAGE_QTY, rpMeasure.TARGET_STOCK,
  rpMeasure.ROP, rpMeasure.SIM_DEMAND_QTY, rpMeasure.SIM_BACKORDER_QTY,
  rpMeasure.SIM_RP_ORDER, rpMeasure.LAST_RELEASED_PURCHASE_QTY,
  rpMeasure.LAST_RELEASED_REPLENISHMENT_QTY,
  rpMeasure.SIM_ARRIVAL, rpMeasure.SIM_SHIPMENT_QTY,
  rpMeasure.SIM_BOH, rpMeasure.SIM_EOH, rpMeasure.SIM_INV_COV_DAYS
];

const psiSimulationDefaultMeasures = [
  rpMeasure.DEMAND_QTY,rpMeasure.BACKORDER_QTY, rpMeasure.RP_ORDER,
  rpMeasure.ARRIVAL_QTY, rpMeasure.ARRIVAL_QTY_CFM, rpMeasure.SHIPMENT_QTY, rpMeasure.SHIPMENT_QTY_CFM,
  rpMeasure.BOH, rpMeasure.EOH, rpMeasure.INV_COV_DAYS, rpMeasure.TARGET_STOCK,
  rpMeasure.ROP, rpMeasure.SIM_DEMAND_QTY, rpMeasure.SIM_BACKORDER_QTY,
  rpMeasure.SIM_RP_ORDER, rpMeasure.SIM_ARRIVAL, rpMeasure.SIM_SHIPMENT_QTY,
  rpMeasure.SIM_BOH, rpMeasure.SIM_EOH, rpMeasure.SIM_INV_COV_DAYS
];

const rpChannelPlanningReviewMeasures = [
  rpMeasure.BOH, rpMeasure.DEMAND_QTY, rpMeasure.EOH, rpMeasure.INV_COV_DAYS, rpMeasure.TARGET_STOCK,
  rpMeasure.KIT_FCST_DEMAND_QTY,  rpMeasure.FCST_DEMAND_QTY, rpMeasure.INTERNAL_DEMAND_QTY,
  rpMeasure.ARRIVAL_QTY, rpMeasure.ARRIVAL_QTY_PLAN,
  rpMeasure.ARRIVAL_QTY_CFM, rpMeasure.SHIPMENT_QTY,
  rpMeasure.SHIPMENT_QTY_PLAN, rpMeasure.SHIPMENT_QTY_CFM,
  rpMeasure.SHIPMENT_QTY_FCST, rpMeasure.SHIPMENT_QTY_REPL,
  rpMeasure.BACKORDER_QTY, rpMeasure.RP_ORDER,
  rpMeasure.ROP
];

const rpChannelPlanningReviewDefaultMeasures = [
  rpMeasure.DEMAND_QTY,rpMeasure.BACKORDER_QTY, rpMeasure.RP_ORDER,
  rpMeasure.ARRIVAL_QTY, rpMeasure.ARRIVAL_QTY_CFM, rpMeasure.SHIPMENT_QTY, rpMeasure.SHIPMENT_QTY_CFM,
  rpMeasure.BOH, rpMeasure.EOH, rpMeasure.INV_COV_DAYS, rpMeasure.TARGET_STOCK,
  rpMeasure.ROP
];

const dpDashboardMeasure = {
  SALES_ACTUAL: "salesActual",
  SALES_ACTUAL_PROFIT: "salesActualProfit",
  COGS: "cogs",
  GROSS_MARGIN_P: "grossMarginPer",
  YOY: "salesActualYoY",
  YOY_P: "yoyPer",
  YOY_COGS: "yoyCogs",
  YOY_GP: "yoyGP",
  YOY_GP_P: "yoyGPPer",
  MOM_P: "momPer",
  MOM_GP_P: "momGPPer",
  DEMAND_PLAN: "demandPlan",
  DEMAND_PLAN_COGS: "demandPlanCogs",
  DEMAND_PLAN_GP: "demandPlanGP",
  FINANCE_PLAN: "budgetPlan",
  FINANCE_PLAN_COGS: "budgetPlanCogs",
  FINANCE_PLAN_GP: "budgetPlanGP",
  FIN_ACHIEVE_P: "finAchievePerQty",
  SALES_VS_PLAN_P: "salesVsPlanPer",
  SALES_VS_PLAN_GP_P: "salesVsPlanGPPer",
  SALES_VS_FIN_GP_P: "salesVsBudgetGPPer",
  PLAN_VS_FIN_P: "planVsBudgetPer",
  PLAN_VS_FIN_GP_P: "planVsBudgetGPPer"
}

const tableToMenuName = {
  "z_item_hrchy": "itemHrchy",
  "z_item": "item",
  "z_customer_hrchy": "customerHrchy",
  "z_customer": "customer",
  "z_customer_item": "customerItem",
  "z_location": "location",
  "z_location_item": "locationItem",
  "z_customer_location": "customerLocation",
  "z_bod": "bod",
  "z_bod_item": 'bodItem',
  "z_cust_hrchy_acl": "customerHrchyPermission",
  "z_measure_acl": "measureAccessControl",
  "z_workcenter": "workcenter",
  "z_resource" : "resource",
  "z_route": "route",
  "z_routing": "routing",
  "z_supplier_item": "supplierItem",
  "z_unit_price": "unitPrice",
  "z_purchase_budget": "purchaseBudget",
  'z_purchase_order':  "purchaseOrder",
  "z_matl_receipt_plan": "materialReceiptPlan",
  "z_sales_order": "salesOrder",
  "z_prod_order": "productionOrder",
  "z_sales_txn": "salesTransaction",
  "z_intransit_inv": "intransitInventory",
  "z_inventory_txn": "inventoryTransaction",
  "z_shipment_txn": "shipmentTransaction",
  "z_sales_plan": "salesPlan",
  "z_bf_feature_sales": "bfFeatureSales",
  "z_bf_algo_rule": "bfAlgoRule",
  "z_resource_capacity": "resourceCapa",
  "z_wip": "wip",
  "z_npi_history": "menuDpNpiHistory"
}

const auditEventType = {
  INSERT: "create",
  UPDATE: "update",
  DELETE: "delete",
}

const auditEntityNms = {
    "AppConfig" : "App Config",
    "BfFeatureDate": "BF Feature Date",
    "BfFeatureSales": "BF Feature Sales",
    "BFLeaderBoard": "BF Leaderboard",
    "BfStatus": "BF Status",
    "BFStatus": "BF Status",
    "BOD" : "BOD",
    "z_bod" : "BOD",
    "BODItem" : "BOD Item",
    "z_bod_item" : "BOD Item",
    "BOM": "BOM",
    "z_bom": "BOM",
    "Classification": "Classification",
    "Company": "Company",
    "z_company": "Company",
    "HrchyAcl": "Hierarchy Access Control",
    "CustHrchyItem": "Customer Hierarchy Item",
    "Customer": "Customer",
    "z_customer": "Customer",
    "CustomerHrchy": "Customer Hierarchy",
    "z_customer_hrchy": "Customer Hierarchy",
    "CustomerItem": "Customer Item",
    "z_customer_item": "Customer Item",
    "CustomerLocation": "Customer Location",
    "z_customer_location": "Customer Location",
    "CycleCalendar": "Cycle Calendar",
    "z_cycle_calendar": "Cycle Calendar",
    "z_calendar_group": "Calendar Group",
    "DashboardKpi": "Dashboard KPI",
    "DataLoadJob": "Data Load Job",
    "DataTransformLog": "Data Transform Log",
    "DemandCubeVal": "Demand Cube Value",
    "DemandVal": "Demand Value",
    "DpNote": "DP Note",
    "ExchangeRate": "Exchange Rate",
    "z_exchange_rate": "Exchange Rate",
    "FileStorage": "File Upload & Validation",
    "FinancePlan": "Finance Plan",
    "HrchyConfig": "Hierarchy Config",
    "z_hrchy_config": "Hierarchy Config",
    "HrchyRel": "Hierarchy Relationship",
    "IntransitInv": "Intransit Inventory",
    "InventoryTxn": "Inventory Transaction",
    "IspScenario": "IP Scenario",
    "IspScenarioComp": "IP Scenario Comparison",
    "Item": "Item",
    "z_item": "Item",
    "ItemHrchy": "Item Hierarchy",
    "z_item_hrchy": "Item Hierarchy",
    "LifeCycle": "DP Life cycle Management",
    "Location": "Location",
    "z_location": "Location",
    "LocationItem": "Location Item",
    "z_location_item": "Location Item",
    "MaterialReceiptPlan": "Material Receipt Plan",
    "Measure": "Measure",
    "z_measure": "Measure",
    "MeasureAcl": "Measure Access Control",
    "z_measure_acl": "Measure Access Control",
    "Note": "Note",
    "NpiHistory": "DP Npi History",
    "NpiProfile": "NPI Profile",
    "P13n": "Personalization",
    "PlanConfig": "Plan Config",
    "PlanVersion": "Plan Version",
    "Postn": "Position",
    "z_postn": "Position",
    "PostnApproval": "Position Access Control",
    "z_postn_approval": "Position Access Control",
    "ProdOrder": "Production Order",
    "ProductionResource": "Production Resource",
    "PurchaseBudget": "Purchase Budget",
    "PurchaseOrder": "Purchase Order",
    "Resource": "Resource",
    "z_resource": "Resource",
    "ResourceCapacity": "Resource Capacity",
    "z_resource_capacity": "Resource Capacity",
    "Route": "Production Route",
    "z_route": "Production Route",
    "Routing": "Routing",
    "z_routing": "Routing",
    "SalesOrder": "Sales Order",
    "SalesPlan": "Sales Plan",
    "SalesTxn": "Sales Transaction",
    "ShipmentTxn": "Shipment Transaction",
    "Site": "Site",
    "z_site": "Site",
    "Supplier": "Supplier",
    "z_supplier": "Supplier",
    "SupplierItem": "Supplier Item",
    "z_supplier_item": "Supplier Item",
    "UnitPrice": "Unit Price",
    "z_unit_price": "Unit Price",
    "User": "User",
    "z_user": "User",
    "z_user_acl": "User Access Control",
    "z_user_postn": "User Position",
    "z_user_role": "User Role",
    "z_user_role_rel": "User Role Relationship",
    "Workcenter": "Work Center",
    "z_workcenter": "Work Center",
}

const thresholdTargetMeasures = [
  dpMeasure.SF_AMT, dpMeasure.SF_QTY,
  dpMeasure.MF_AMT, dpMeasure.MF_QTY,
  dpMeasure.FF_AMT, dpMeasure.FF_QTY,
  dpMeasure.MK_AMT, dpMeasure.MK_QTY,
  dpMeasure.PM_QTY
];

const unusedCsvExportMeasure = [
  rpMeasure.KIT_FCST_DEMAND_QTY, rpMeasure.KIT_FCST_DEMAND_AMT,
  rpMeasure.FCST_DEMAND_AMT, rpMeasure.FCST_DEMAND_QTY,
  rpMeasure.INTERNAL_DEMAND_AMT, rpMeasure.INTERNAL_DEMAND_QTY,
  rpMeasure.DOWNSTREAM_DEMAND_QTY_SUM, rpMeasure.DOWNSTREAM_DEMAND_AMT_SUM,
  rpMeasure.DOWNSTREAM_EOH_QTY_SUM, rpMeasure.DOWNSTREAM_EOH_AMT_SUM,
  rpMeasure.INV_COV_DAYS, rpMeasure.SIM_INV_COV_DAYS, rpMeasure.SHIPMENT_SHORTAGE_QTY,
  rpMeasure.SHIPMENT_QTY_FCST, rpMeasure.SHIPMENT_AMT_FCST,
  rpMeasure.SHIPMENT_QTY_REPL, rpMeasure.SHIPMENT_AMT_REPL
];

const unusedBulkUpsertMeasure = [
  dpMeasure.SUGGESTED_MP_QTY.cd, "INV_BOH_QTY", "INV_EOH_QTY", "TARGET_INV_QTY_EOH", "MF_VS_SUGGESTED_QTY",
  "TURN_DAYS_TARGET"
];

const deleteRelations = {
  bod: [
    {name: "bodItem", action: "cascade", syncActive: true }
  ],
  calendarGrp: [
    {name: "cycleCalendar", action: "disconnect"},
    {name: "workcenter", action: "disconnect"},
    {name: "productionResource", action: "disconnect"}
  ],
  cycleCalendar: [
    {name: "bod", action: "disconnect"},
    {name: "locationItem", action: "disconnect"}
  ],
  customer: [
    {name: "customerItem", action: "cascade", syncActive: true},
    {name: "customerLocation", action: "cascade", syncActive: true},
  ],
  customerHrchy: [
    {name: "lowerLevelCustomerHrchy", action: "cascade", syncActive: true},
    {name: "customer", action: "disconnect"},
    {name: "customerItem", action: "deactivate", syncActive: true, leafFalse: true},
    {name: "customerHrchyPermission", action: "cascade"}
  ],
  hrchyConfig: [
    {name: "itemHrchy", action: "cascade"},
    {name: "customerHrchy", action: "cascade"},
    {name: "customerHrchyPermission", action: "cascade"},
    {name: "item", action: "disconnect"},
    {name: "customer", action: "disconnect"},
  ],
  item: [
    {name: "bom", action: "cascade"},
    {name: "bodItem", action: "cascade"},
    {name: "customerItem", action: "cascade"},
    {name: "customerLocation", action: "cascade"},
    {name: "locationItem", action: "cascade"},
    {name: "supplierItem", action: "cascade"},
    {name: "productionRoute", action: "cascade"},
    {name: "routing", action: "cascade"}
  ],
  itemHrchy: [
    {name: "lowerLevelItemHrchy", action: "cascade", syncActive: true},
    {name: "item", action: "disconnect"},
    {name: "customerItem", action: "deactivate",syncActive: true, leafFalse: true},
  ],
  location: [
    {name: "bod", action: "cascade", syncActive: true},
    {name: "bodItem", action: "cascade", syncActive: true},
    {name: "locationItem", action: "cascade", syncActive: true},
    {name: "customerLocation", action: "cascade", syncActive: true},
    {name: "supplierItem", action: "cascade", syncActive: true},
    {name: "workcenter", action: "cascade", syncActive: true},
    {name: "productionResource", action: "cascade", syncActive: true},
    {name: "resourceCapa", action: "cascade", syncActive: true},
    {name: "routing", action: "cascade"}
  ],
  postn: [
    {name: "lowerLevelPostn", action:"cascade", syncActive: true},
    {name: "customerHrchyPermission", action: "cascade"},
    {name: "measureAccessControl", action: "cascade"}
  ],
  resource: [
    {name: "routing", action: "cascade"},
    {name: "resourceCapa", action: "cascade", syncActive: true }
  ],
  route: [
    {name: "routing", action: "cascade"}
  ],
  site: [
    {name: "location", action: "disconnect"},
  ],
  supplier: [
    {name: "supplierItem", action: "cascade", syncActive: true }
  ],
  workcenter: [
    {name: "productionResource", action: "cascade", syncActive: true },
    {name: "resourceCapa", action: "cascade", syncActive: true },
    {name: "routing", action: "cascade"}
  ]
}

const getTranslatedName = (name) => {
    if (name.startsWith('lowerLevel')) {
      const baseName = name.charAt(10).toLowerCase() + name.slice(11);
      return `${t("lowerLevel")} ${t(baseName)}`;
    }
    return t(name);
  };

const makeMessage = (deleteTable, operationType, selectOption = false) => {
  if (!deleteTable || deleteTable.length === 0) return "";
  const grouped = {
    cascade: [],
    disconnect: [],
    deactivate: [],
    leafFalse: []
  };

  deleteTable.forEach(item => {
    if (item.name) {
      const action = item.action || 'cascade';

      if (operationType === 'delete') {
        if (action === 'cascade') {
          grouped.cascade.push(item.name);
        } else if (action === 'disconnect') {
          grouped.disconnect.push(item.name);
        } else if (action === 'deactivate') {
          grouped.deactivate.push(item.name);
        }
      } else if (operationType === 'deactivate') {
        if (item.syncActive) {
          grouped.deactivate.push(item.name);
        }
      } else if (operationType === 'leafFalse') {
        if (item.leafFalse) {
          grouped.leafFalse.push(item.name);
        }

        if (action === 'disconnect') {
          grouped.disconnect.push(item.name);
        }
      }
    }
  });

  let message = "";

  if (operationType === 'delete') {
    if (grouped.cascade.length > 0) {
      if (!selectOption) {
        message += `- ${t("MSG_WillBeDeleted")}:\n`;
      }
      grouped.cascade.forEach(name => {
        message += `  ・ ${getTranslatedName(name)}\n`;
      });
      message += "\n";
    }

    if (grouped.disconnect.length > 0) {
      if (!selectOption) {
        message += `- ${t("MSG_WillBeUnlinked")}:\n`;
      }
      grouped.disconnect.forEach(name => {
        message += `  ・ ${getTranslatedName(name)}\n`;
      });
      message += "\n";
    }

    if (grouped.deactivate.length > 0) {
      if (!selectOption) {
        message += `- ${t("MSG_WillBeDeactivated")}:\n`;
      }
      grouped.deactivate.forEach(name => {
        message += `  ・ ${getTranslatedName(name)}\n`;
      });
      message += "\n";
    }
  } else if (operationType === 'deactivate') {
    if (grouped.deactivate.length > 0) {
      message += `- ${t("MSG_WillBeDeactivated")}:\n`;
      grouped.deactivate.forEach(name => {
        message += `  ・ ${getTranslatedName(name)}\n`;
      });
    }
  } else if (operationType === 'leafFalse') {
    if (grouped.leafFalse.length > 0) {
      message += `- ${t("MSG_WillBeDeactivated")}:\n`;
      grouped.leafFalse.forEach(name => {
        message += `  ・ ${getTranslatedName(name)}\n`;
      });
    }

    if (grouped.disconnect.length > 0) {
      message += `- ${t("MSG_WillBeUnlinked")}:\n`;
      grouped.disconnect.forEach(name => {
        message += `  ・ ${getTranslatedName(name)}\n`;
      });
      message += "\n";
    }
  }

  return message.trim();
}

const limitType = [
    { value: "qty", text: "qty" },
    { value: "lot", text: "lot" },
];

const CodeUtil = {
  dpMeasure,
  dpVersion,
  dpBfStatus,
  dpApproveStatus,
  USER_MEASURE,
  channelOnlyMeasureCds,
  dpComputeDefaultMeasure,
  dpcommonMeasureCd,
  dpPermission,
  dpConfig,
  SHOW_POS,
  SHOW_CHANNEL,
  dpMeasureType,
  nonRuleMeasureCds,
  aggEditableMeasureCds,
  dashboardMeasure,
  dashboardTitle,
  dashboardMeasures,
  dpChartType,
  dpABCConfig,
  dpAccessControlTab,
  dpDisAggRules,
  dpDisAggTarget,
  dpAggRules,
  dpInitalValues,
  dpSettingCode,
  dpP13N,
  dpPlanActualMeasures,
  getDpPlanActualAlertMeasures,
  dpPlanDisableMeasures,
  dpDashboardMeasure,
  dpTrackingMeasures,
  dpTransformMeasure,
  bfMetric,
  bfAlgorithm,
  ipMeasure,
  ipVersionStatusCode,
  rpMeasure,
  rpReviewMeasures,
  defaultRpReviewMeasures,
  psiSimulationMeasures,
  psiSimulationDefaultMeasures,
  rpChannelPlanningReviewMeasures,
  rpChannelPlanningReviewDefaultMeasures,
  rpPolicyCd,
  roles,
  rpVersionStatusCode,
  rpDemandDistributionPolicy,
  ipRpMeasure,
  ipRpMpMeasure,
  loginType,
  module,
  versionStatusCode,
  customer,
  item,
  buckets,
  isWeekBucket,
  getCurrencySymbol,
  getNoteKey,
  MP_NOTE_PAGES,
  makeKey,
  calculateLotSize,
  dayOfWeek,
  toggleType,
  filterType,
  muicolor,
  locationType,
  itemType,
  calendarType,
  orderType,
  ganttOrderType,
  attributes,
  ABCClassConfig,
  classifiDimLCode,
  classifiBaseCode,
  ipPolicyCd,
  transformSourceData,
  hrchyNum,
  displayDigit,
  timeColumnDecimalLimit,
  workbenchAlertObjs,
  mpDemandType,
  shipmentCondition,
  intransitCondition,
  meetingAgendaDateCondition,
  orderListCondition,
  mpMeasure,
  scheduleTargetObj,
  scheduleStatusObj,
  mpTimeUom,
  mpTimeBase,
  mpPlanConfig,
  datePriorityNameByCode,
  cycleUoms,
  planStrategies,
  orderStatusCode,
  deleteInsertTables,
  deleteTables,
  amtCurrencyMeasure,
  thresholdTargetMeasures,
  limitVersion,
  priorityItems,
  unusedCsvExportMeasure,
  unusedBulkUpsertMeasure,
  inventoryCoverageDaysPolicy,
  getSourceMeasureList,
  tableToMenuName,
  ipSettings,
  calcType,
  auditEventType,
  auditEntityNms,
  deleteRelations,
  makeMessage,
  limitType,
  versionStatusLabel,
};

export default CodeUtil;
